// *******************************************************************************
// Product CTA
// *******************************************************************************

const productCta = document.querySelectorAll('.product-cta');

if (productCta.length > 0) {
  productCta.forEach((parent) => {
    const primaryImage = parent.querySelector('.product-cta__image-primary');
    const secondaryImage = parent.querySelector('.product-cta__image-secondary');

    gsap.to(primaryImage, {
      y: '20%',
      scrollTrigger: {
        trigger: primaryImage,
        start: 'top 60%',
        end: 'bottom 60%',
        scrub: 3,
      },
    });

    gsap.to(secondaryImage, {
      y: '-20%',
      scrollTrigger: {
        trigger: primaryImage,
        start: 'top 60%',
        end: 'bottom 60%',
        scrub: 3,
      },
    });
  });
}
